(() => {
  const SELECTOR = '[data-featured-products-artesanal]';

  function initSection(section) {
    if (!section || section.dataset.featuredProductsReady === 'true') return;
    section.dataset.featuredProductsReady = 'true';

    const track = section.querySelector('[data-featured-products-track]');
    const prev = section.querySelector('[data-featured-products-prev]');
    const next = section.querySelector('[data-featured-products-next]');

    if (track && prev && next) {
      const updateArrows = () => {
        const maxScroll = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maxScroll;
      };

      const scrollByPage = (direction) => {
        const amount = Math.max(track.clientWidth * 0.82, 240);
        track.scrollBy({ left: amount * direction, behavior: 'smooth' });
      };

      prev.addEventListener('click', () => scrollByPage(-1));
      next.addEventListener('click', () => scrollByPage(1));
      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      requestAnimationFrame(updateArrows);
    }

    section.querySelectorAll('[data-featured-products-quick-add]').forEach((form) => {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        const button = form.querySelector('button[type="submit"]');
        const status = form.querySelector('.card-product-artesanal__status');
        if (!button) return;

        const addLabel = button.dataset.addLabel || button.textContent;
        button.disabled = true;
        button.textContent = button.dataset.addingLabel || addLabel;
        if (status) status.textContent = '';

        try {
          const response = await fetch(form.action + '.js', {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: new FormData(form)
          });

          if (!response.ok) throw new Error('Add to cart failed');

          button.textContent = button.dataset.addedLabel || addLabel;
          if (status) status.textContent = button.dataset.addedLabel || addLabel;
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

          const cartBubble = document.querySelector('.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble span:not(.visually-hidden)');
          if (cartBubble) {
            try {
              const cartResponse = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
              const cart = await cartResponse.json();
              cartBubble.textContent = cart.item_count;
            } catch (_error) {}
          }
        } catch (error) {
          button.textContent = button.dataset.errorLabel || addLabel;
          if (status) status.textContent = button.dataset.errorLabel || addLabel;
        } finally {
          setTimeout(() => {
            button.disabled = false;
            button.textContent = addLabel;
          }, 1600);
        }
      });
    });
  }

  function initAll(root = document) {
    root.querySelectorAll(SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
